/**
 * Created by sven.bluege on 04.04.2017.
 */


window.Eventgallery = require('exports-loader?Eventgallery!../common/js/EventgalleryTools.js');

require('./js/EventgalleryCart.js');
require('./js/EventgalleryBehavior.js');
require('./js/EventgalleryImage.js');
require('./js/EventgalleryRow.js');
require('./js/EventgalleryImageList.js');
require('./js/EventgalleryCart.js');
require('./js/EventgalleryEventsList.js');
require('./js/EventgalleryEventsTiles.js');
require('./js/EventgalleryGridCollection.js');
require('./js/EventgalleryJSGallery2.js');
require('./js/EventgalleryLazyload.js');
require('./js/EventgallerySizeCalculator.js');
require('./js/EventgallerySocialShareButton.js');
require('./js/EventgallerySquareList.js');
require('./js/EventgalleryTilesCollection.js');
require('./js/EventgalleryTouch.js');
require('./js/jquery.colorbox.js');
require('./js/jquery.colorbox.init.js');
require('./js/Modules.js');

require('./less/eventgallery.less');
require('./less/font-awesome/font-awesome.less');
require('./css/colorbox.css');




// WEBPACK FOOTER //
// ./eventgallery.js